import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import type {
  FetchAgencyCascadeSchedulingPlanAction,
  FetchAgencyCascadeSchedulingPlanPayload,
} from './actions'
import type { SchedulingPlan } from './types'

type SchedulingPlanResult = {
  payload: SchedulingPlan
  response: Response
  meta: { options: FetchAgencyCascadeSchedulingPlanPayload }
}

export const getAgencyCascadeSchedulingPlan = ({
  payload,
}: FetchAgencyCascadeSchedulingPlanAction): Promise<SchedulingPlanResult> =>
  new Promise((resolve, reject) => {
    handleCall(
      apiRequest({ path: `/admin/agency_cascade_scheduling_plans/${payload.planId}`, method: 'GET' }),
      resolve,
      reject,
      false,
      payload,
    )
  })
